export default "__VITE_ASSET__DpGHAJn5__"